var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconPlus = function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.498 4.615.121.007c.557.06.991.532.991 1.106V11h5.273c.573 0 1.045.434 1.106.992l.006.12-.006.122c-.06.557-.533.991-1.106.991h-5.274v5.273c0 .573-.433 1.045-.99 1.106l-.122.006-.12-.006a1.113 1.113 0 0 1-.992-1.106v-5.274H6.112a1.111 1.111 0 0 1-1.105-.99L5 12.112l.007-.12c.06-.558.532-.992 1.105-.992h5.273V5.728c0-.574.434-1.046.992-1.106l.12-.007z"
  })));
};

export default SvgIconPlus;